'use client';

import { CSSProperties, ReactNode, useLayoutEffect, useRef } from 'react';
import { createStableResizeHandler, getViewportHeight } from './viewport-utils';

type SimulaixViewportStyle = CSSProperties & {
    '--simulaix-vh': string;
};

export default function SimulaixViewport({
    children,
}: {
    children: ReactNode;
}) {
    const rootRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const root = rootRef.current;
        if (!root) return;

        let height = getViewportHeight();

        const setViewportHeight = () => {
            root.style.setProperty('--simulaix-vh', `${height}px`);
        };

        const handleResize = createStableResizeHandler(() => {
            height = getViewportHeight();
            setViewportHeight();
        });

        setViewportHeight();
        window.addEventListener('resize', handleResize);
        window.visualViewport?.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.visualViewport?.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    return (
        <div
            ref={rootRef}
            className="contents"
            style={{ '--simulaix-vh': '100svh' } as SimulaixViewportStyle}
        >
            {children}
        </div>
    );
}
